import { apps } from '../rolesAndPermission';

export const settingsPayrollIntegrationModule = {
  settings: {
    id: 65,
    moduleName: 'Settings',
  },
  payroll: {
    id: 66,
    moduleName: 'Payroll',
  },
  integrations: {
    id: 67,
    moduleName: 'Integrations',
  },
} as const;
export const settingsPayrollIntegrationModuleList = Object.entries(settingsPayrollIntegrationModule).map(
  ([key, v]) => ({
    key,
    createdBy: 'System',
    ...v,
  })
);

export const settingsPayrollIntegrationFeatures = {
  integrations: {
    id: 185,
    featureName: 'Integrations',
  },
  onboarding: {
    id: 186,
    featureName: 'Onboarding',
  },
  setup: {
    id: 187,
    featureName: 'Setup',
  },
  'receipt-settings': {
    id: 188,
    featureName: 'Receipt Settings',
  },
  'business-hours': {
    id: 189,
    featureName: 'Business Hours',
  },
  benefits: {
    id: 197,
    featureName: 'benefits',
  },
} as const;

export const settingsPayrollIntegrationFeaturesFeaturesList = Object.entries(settingsPayrollIntegrationFeatures).map(
  ([key, v]) => ({
    key,
    ...v,
    createdBy: 'System',
  })
);

export const settingsPayrollIntegrationAppModule = [
  { appId: apps.dashboard.id, moduleId: settingsPayrollIntegrationModule['settings'].id },
  { appId: apps.dashboard.id, moduleId: settingsPayrollIntegrationModule['payroll'].id },
  { appId: apps.dashboard.id, moduleId: settingsPayrollIntegrationModule['integrations'].id },
];

export const settingsPayrollIntegrationFeaturesModule = [
  {
    moduleId: settingsPayrollIntegrationModule['settings'].id,
    featureId: settingsPayrollIntegrationFeatures['receipt-settings'].id,
  },
  {
    moduleId: settingsPayrollIntegrationModule['settings'].id,
    featureId: settingsPayrollIntegrationFeatures['business-hours'].id,
  },
  {
    moduleId: settingsPayrollIntegrationModule['payroll'].id,
    featureId: settingsPayrollIntegrationFeatures['onboarding'].id,
  },
  {
    moduleId: settingsPayrollIntegrationModule['payroll'].id,
    featureId: settingsPayrollIntegrationFeatures['setup'].id,
  },
  {
    moduleId: settingsPayrollIntegrationModule['integrations'].id,
    featureId: settingsPayrollIntegrationFeatures['integrations'].id,
  },
  {
    moduleId: settingsPayrollIntegrationModule['payroll'].id,
    featureId: settingsPayrollIntegrationFeatures['benefits'].id,
  },
];
